/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueType = exports.Transparency = exports.SortOrder = exports.ServiceStatus = exports.Segment = exports.ScheduleStatus = exports.ResponseType = exports.ResourceStatus = exports.RecurringIntervalType = exports.ProviderStatus = exports.PricingPlanStatus = exports.PremiumInfo = exports.NotificationType = exports.LocationsLocationType = exports.LocationStatus = exports.LocationLocationType = exports.DayOfWeek = exports.Day = exports.ConferenceType = exports.CategoryStatus = exports.BusinessType = exports.BusinessNotificationType = exports.ApprovalStatus = void 0;
var ApprovalStatus;
(function (ApprovalStatus) {
    ApprovalStatus["UNDEFINED"] = "UNDEFINED";
    ApprovalStatus["PENDING"] = "PENDING";
    ApprovalStatus["APPROVED"] = "APPROVED";
    ApprovalStatus["DECLINED"] = "DECLINED";
})(ApprovalStatus = exports.ApprovalStatus || (exports.ApprovalStatus = {}));
var BusinessNotificationType;
(function (BusinessNotificationType) {
    BusinessNotificationType["UNDEFINED"] = "UNDEFINED";
    BusinessNotificationType["CONFIRMATION_EMAIL"] = "CONFIRMATION_EMAIL";
})(BusinessNotificationType = exports.BusinessNotificationType || (exports.BusinessNotificationType = {}));
var BusinessType;
(function (BusinessType) {
    BusinessType["UNDEFINED"] = "UNDEFINED";
    BusinessType["ON_THE_GO"] = "ON_THE_GO";
    BusinessType["ON_LOCATION"] = "ON_LOCATION";
})(BusinessType = exports.BusinessType || (exports.BusinessType = {}));
var CategoryStatus;
(function (CategoryStatus) {
    CategoryStatus["CREATED"] = "CREATED";
    CategoryStatus["DELETED"] = "DELETED";
})(CategoryStatus = exports.CategoryStatus || (exports.CategoryStatus = {}));
var ConferenceType;
(function (ConferenceType) {
    ConferenceType["UNDEFINED"] = "UNDEFINED";
    ConferenceType["ONLINE_MEETING_PROVIDER"] = "ONLINE_MEETING_PROVIDER";
    ConferenceType["CUSTOM"] = "CUSTOM";
})(ConferenceType = exports.ConferenceType || (exports.ConferenceType = {}));
var Day;
(function (Day) {
    Day["UNDEFINED"] = "UNDEFINED";
    Day["MON"] = "MON";
    Day["TUE"] = "TUE";
    Day["WED"] = "WED";
    Day["THU"] = "THU";
    Day["FRI"] = "FRI";
    Day["SAT"] = "SAT";
    Day["SUN"] = "SUN";
})(Day = exports.Day || (exports.Day = {}));
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
})(DayOfWeek = exports.DayOfWeek || (exports.DayOfWeek = {}));
var LocationLocationType;
(function (LocationLocationType) {
    LocationLocationType["UNDEFINED"] = "UNDEFINED";
    LocationLocationType["OWNER_BUSINESS"] = "OWNER_BUSINESS";
    LocationLocationType["OWNER_CUSTOM"] = "OWNER_CUSTOM";
    LocationLocationType["CUSTOM"] = "CUSTOM";
})(LocationLocationType = exports.LocationLocationType || (exports.LocationLocationType = {}));
var LocationStatus;
(function (LocationStatus) {
    LocationStatus["ACTIVE"] = "ACTIVE";
    LocationStatus["INACTIVE"] = "INACTIVE";
})(LocationStatus = exports.LocationStatus || (exports.LocationStatus = {}));
var LocationsLocationType;
(function (LocationsLocationType) {
    LocationsLocationType["UNKNOWN"] = "UNKNOWN";
    LocationsLocationType["BRANCH"] = "BRANCH";
    LocationsLocationType["OFFICES"] = "OFFICES";
    LocationsLocationType["RECEPTION"] = "RECEPTION";
    LocationsLocationType["HEADQUARTERS"] = "HEADQUARTERS";
})(LocationsLocationType = exports.LocationsLocationType || (exports.LocationsLocationType = {}));
var NotificationType;
(function (NotificationType) {
    NotificationType["UNDEFINED"] = "UNDEFINED";
    NotificationType["CONFIRMATION_EMAIL"] = "CONFIRMATION_EMAIL";
    NotificationType["CANCELLATION_EMAIL"] = "CANCELLATION_EMAIL";
    NotificationType["REMINDER_EMAIL"] = "REMINDER_EMAIL";
    NotificationType["REMINDER_SMS"] = "REMINDER_SMS";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
var PremiumInfo;
(function (PremiumInfo) {
    PremiumInfo["UNDEFINED"] = "UNDEFINED";
    PremiumInfo["BOOKINGS_PREMIUM"] = "BOOKINGS_PREMIUM";
    PremiumInfo["WIX_PREMIUM"] = "WIX_PREMIUM";
    PremiumInfo["NO_PREMIUM"] = "NO_PREMIUM";
    PremiumInfo["DAYFUL_PREMIUM"] = "DAYFUL_PREMIUM";
})(PremiumInfo = exports.PremiumInfo || (exports.PremiumInfo = {}));
var PricingPlanStatus;
(function (PricingPlanStatus) {
    PricingPlanStatus["UNDEFINED"] = "UNDEFINED";
    PricingPlanStatus["ACTIVE"] = "ACTIVE";
    PricingPlanStatus["ARCHIVED"] = "ARCHIVED";
})(PricingPlanStatus = exports.PricingPlanStatus || (exports.PricingPlanStatus = {}));
var ProviderStatus;
(function (ProviderStatus) {
    ProviderStatus["UNDEFINED"] = "UNDEFINED";
    ProviderStatus["CONNECTED"] = "CONNECTED";
    ProviderStatus["DISCONNECTED"] = "DISCONNECTED";
})(ProviderStatus = exports.ProviderStatus || (exports.ProviderStatus = {}));
var RecurringIntervalType;
(function (RecurringIntervalType) {
    RecurringIntervalType["UNDEFINED"] = "UNDEFINED";
    RecurringIntervalType["EVENT"] = "EVENT";
    RecurringIntervalType["TIME_AVAILABILITY"] = "TIME_AVAILABILITY";
    RecurringIntervalType["AVAILABILITY"] = "AVAILABILITY";
})(RecurringIntervalType = exports.RecurringIntervalType || (exports.RecurringIntervalType = {}));
var ResourceStatus;
(function (ResourceStatus) {
    ResourceStatus["UNDEFINED"] = "UNDEFINED";
    ResourceStatus["CREATED"] = "CREATED";
    ResourceStatus["DELETED"] = "DELETED";
    ResourceStatus["UPDATED"] = "UPDATED";
})(ResourceStatus = exports.ResourceStatus || (exports.ResourceStatus = {}));
var ResponseType;
(function (ResponseType) {
    ResponseType["CONSISTENT"] = "CONSISTENT";
    ResponseType["EVENTUALLY_CONSISTENT"] = "EVENTUALLY_CONSISTENT";
})(ResponseType = exports.ResponseType || (exports.ResponseType = {}));
var ScheduleStatus;
(function (ScheduleStatus) {
    ScheduleStatus["UNDEFINED"] = "UNDEFINED";
    ScheduleStatus["CREATED"] = "CREATED";
    ScheduleStatus["CANCELLED"] = "CANCELLED";
})(ScheduleStatus = exports.ScheduleStatus || (exports.ScheduleStatus = {}));
var Segment;
(function (Segment) {
    Segment["PUBLISHED"] = "PUBLISHED";
    Segment["SAVED"] = "SAVED";
})(Segment = exports.Segment || (exports.Segment = {}));
var ServiceStatus;
(function (ServiceStatus) {
    ServiceStatus["CREATED"] = "CREATED";
    ServiceStatus["DELETED"] = "DELETED";
})(ServiceStatus = exports.ServiceStatus || (exports.ServiceStatus = {}));
var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
var Transparency;
(function (Transparency) {
    Transparency["UNDEFINED"] = "UNDEFINED";
    Transparency["FREE"] = "FREE";
    Transparency["BUSY"] = "BUSY";
})(Transparency = exports.Transparency || (exports.Transparency = {}));
var ValueType;
(function (ValueType) {
    ValueType["SHORT_TEXT"] = "SHORT_TEXT";
    ValueType["LONG_TEXT"] = "LONG_TEXT";
    ValueType["CHECK_BOX"] = "CHECK_BOX";
})(ValueType = exports.ValueType || (exports.ValueType = {}));
//# sourceMappingURL=types.js.map